module.exports = __webpack_public_path__ + "static/media/manage-access-typeform.8dda0f2c.gif";